import { observable, makeObservable } from 'mobx';
import { runtime } from '../../../classes/runtime/Runtime';
export function editable(attr) {
    if (runtime.runtimePermissions.hasEditFunctionality) {
        if (attr)
            return observable[attr];
        return observable;
    }
    return undefined;
}
export function editObservable(obj) {
    if (runtime.runtimePermissions.hasEditFunctionality) {
        makeObservable(obj);
    }
}
